import { cloneDeep, isEqual } from 'lodash'

import { SendingTypes } from '@sigmasms/shared-types'

import { proxy, services } from '@/utils'

import { setTariffPrice } from '@/components/services/tariffs/utils'

import render from './render'

const getHintPathBySource = source => {
  switch (source) {
    case SendingTypes.voice: return [ 'perCall', 'perSecond' ]
    case 'apisender': return [ 'perPeriod' ]
    default: return [ 'default' ]
  }
}

export default {
  name: 'Prices',

  mixins: [ proxy({ type: 'array' }) ],

  props: {
    source: String,
    readonly: Boolean
  },

  watch: {
    source() {
      this.proxy = setTariffPrice(this.proxy, this.source)
    }
  },

  computed: {
    hint() {
      return getHintPathBySource(this.source).map(hint => {
        return this.getTranslate(`${services.tariffs}.hints.${hint}`)
      })
    }
  },

  methods: {
    _inputFilter(value) {
      return cloneDeep(value)
    },

    transmitValue() {
      if (!isEqual(this.proxy, this.value)) {
        this.$emit('input', cloneDeep(this.proxy))
      }
    }
  },

  render
}
